// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2nuxi","list":"BalanceDue_list__2mK_F","listRow":"BalanceDue_listRow__3ylhu","total":"BalanceDue_total__oQLak"};